import { MouseEvent, RefObject, TouchEvent, useEffect } from 'react';

type ClickableEvent<T> = MouseEvent<T> | TouchEvent<T>;

// TODO: Fix types
const useOnClickOutside = <T extends HTMLElement = HTMLElement>(
  ref: RefObject<T>,
  handler: () => void,
  parent?: any,
): void => {
  useEffect(() => {
    const wrapper = parent || document;

    const listener = (event: ClickableEvent<HTMLElement>) => {
      const el = ref.current;

      if (
        !el ||
        !document.contains(event.target as Node) ||
        el.contains(event.target as Node) ||
        el.id === (event.target as HTMLElement).dataset.id
      ) {
        return;
      }

      handler();
    };

    wrapper.addEventListener('click', listener);

    return () => {
      wrapper.removeEventListener('click', listener);
    };
  }, [ref, handler, parent]);
};

export default useOnClickOutside;
